import { render, staticRenderFns } from "./index_pc.vue?vue&type=template&id=4b232dac&scoped=true&"
import script from "./index_pc.vue?vue&type=script&lang=js&"
export * from "./index_pc.vue?vue&type=script&lang=js&"
import style0 from "./index_pc.vue?vue&type=style&index=0&id=4b232dac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b232dac",
  null
  
)

export default component.exports